import { Component, Inject, OnChanges, OnInit, SimpleChanges, Pipe } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MaterialModule } from 'src/app/shared/material'
import { MatSelectModule } from '@angular/material/select'
import { ReactiveFormsModule, FormsModule, NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar'
import { Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { of, pipe } from 'rxjs'
import { AdresssService } from '../adresss.service';
import { SpinnerdetialComponent } from 'src/app/helpers/loading/spinnerdetial/spinnerdetial.component'

@Component({
  selector: 'app-formmarker',
  standalone: true,
  imports: [CommonModule,MatInputModule, SpinnerdetialComponent, FormsModule, ReactiveFormsModule, MatFormFieldModule, MaterialModule, MatSelectModule],
  template: `
    <mat-dialog-content>
    <button mat-button mat-dialog-close="myData" class="border-none float-right">
      <img src="../../../../assets/maps/icons8-close-window-48.png" width="30" height="30" alt="">
    </button>
      <form #form="ngForm" (ngSubmit)="doAddAddress(form)" >
        <h4>Data LatLong</h4>
        <mat-form-field class="mt-2" style="width: 100%;">
          <input  [disabled]="true"[value]="latandlng" type="text" matInput #inputField [placeholder]="'latlong'" />
        </mat-form-field>
        <mat-form-field style="width: 100%;">
        <input matInput  name="address" [value]="alamatMap.address" type="text" [placeholder]="'alamat'">
        </mat-form-field>
        <mat-form-field style="width: 100%;">
        <input matInput  name="kec"  type="text" [placeholder]="'kec'">
        </mat-form-field>
        <mat-form-field style="width: 100%;">
        <input matInput  name="des"  type="text" [placeholder]="'des'">
        </mat-form-field>
        <mat-form-field style="width: 100%;">
        <input matInput  name="rtrw" type="text" [placeholder]="'rt/rw'">
        </mat-form-field>
        <div class="mt-5">
          <mat-label>Choose Caracter {{selected}}</mat-label>
          <mat-select>
              <mat-option ngModel name="icon" *ngFor="let itemIcon of icon" [value]="icon">
                <div class="grid grid-cols-2">
                  <span>{{itemIcon.title}}</span> <img src="{{itemIcon.name}}" alt="">
                </div>
              </mat-option>
          </mat-select>
        </div>
        <div class="button justify-end gap-4 mt-14">
            <button class="btn btn-outline-primary w-34 col-span-10" type="submit">
             <span *ngIf="!isLoading">
               ADD LOCATION
             </span>
             <span *ngIf="isLoading">
              <app-spinnerdetial></app-spinnerdetial>
             </span>
            </button>
        </div>
      </form>
    </mat-dialog-content>
  `,
  styles: [],
})
export class FormmarkerComponent implements OnInit, OnChanges {
  latlong: any[] = []
  alamatMap: any = [];
  filteredData: any
  isLoading = false
  selected: any
  icon:any = [
    {
      title: 'salon man',
      name: '../../../../assets/maps/icons8-shaving-man-48.png',
    },
    {
      title: 'kebun',
      name: '../../../../assets/maps/icons8-cheburashka-48.png'
    },
    {
      title: 'sirkus',
      name: '../../../../assets/maps/icons8-elephant-circus-48.png'
    },
    {
      title: 'india man',
      name: '../../../../assets/maps/icons8-smurf-48.png'
    }
  ]
  kec: any
  kel: any
  rtrw: any
  latlng: any[] = []
  latandlng: any[] = []

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private snackbar: MatSnackBar, private router: Router, private addressService: AdresssService) {
    // console.log(this.data.dataDialog, 'mat data');
    this.alamatMap = this.data.dataDialog[0]
    console.log(this.alamatMap, 'const')
    this.latlong.push(this.data.dataDialog[0].position.lat, this.data.dataDialog[0].position.lng)
    console.log(this.latlong[0], 'long')
    this.latlng.push({
      position: {
        lat: this.latlong[0],
        lng: this.latlong[1]
      }
    })
    console.log(this.latlng[0].position, 'good')
    this.latandlng.push(this.latlng[0].position.lat, this.latlng[0].position.lng)
    console.log(this.latandlng)


  }

  ngOnInit(): void {
    // this.getDataById()
  }

  ngOnChanges(simple: SimpleChanges){
    simple.latlong
    simple.alamatMap
    // this.latlong.push(this.data.dataDialog[0].position.lat, this.data.dataDialog[0].position.lng)
    // this.alamatMap.push(this.data.dataDialog[1])
  }

  close(){
    this.latlong.push('')
    this.alamatMap.push('')
    // this.latlong.push(this.data.dataDialog[0].position.lat, this.data.dataDialog[0].position.lng)
    // this.alamatMap.push(this.data.dataDialog[1])
    // location.reload()
  }

  getDataById(){
    this.addressService.getMapById(this.alamatMap.id).subscribe((value: any) => {
      console.log(value, 'id by')
    })
  }

  doAddAddress(form: NgForm){
    this.isLoading = true;
    const data = {
      position: {
        lat: this.alamatMap.position.lat,
        lng: this.alamatMap.position.lng,
      },
      address: this.alamatMap.address ? this.alamatMap.address : form.value.address,
      kec: form.value.kec ? form.value.kec : this.kec,
      kel: form.value.kel ? form.value.kel : this.kel,
      rtrw: form.value.rtrw ? form.value.rtrw : this.rtrw,
      icon: form.value.icon ? form.value.icon : this.icon
    }
    this.addressService.doAddLocation(data).subscribe((value: any) => {
      this.isLoading = false;
      this.snackbar.open('success add', 'close', {
        duration: 2000,
      });
    })
  }
}
